import { ImageLoaderProps } from "next/legacy/image";
import { CMS_ASSETS_DOMAIN } from "lib/constants";

interface Transform {
  format?: "auto" | "svg" | "jpg" | "png" | "webp";
}

const createLoaderWithTransform = ({ format }: Transform) => {
  function normalizeSrc(src: string): string {
    return src[0] === "/" ? src.slice(1) : src;
  }

  // https://nextjs.org/docs/app/api-reference/next-config-js/images#cloudflare
  return function imageLoader({ src, width, quality }: ImageLoaderProps) {
    const params = [`format=${format ?? "auto"}`, `quality=${quality ?? 75}`, `width=${width}`];
    let paramsString = `${params.join(",")}`;

    return `${CMS_ASSETS_DOMAIN}/${normalizeSrc(src)}/${paramsString}`;
  };
};

export { createLoaderWithTransform };
export type { Transform };
